import { Currency } from '../types';

export const getFilteredCurrenciesBySearch = (currenciesToFilter: Currency[], searchTerm: string) => {
    if (!searchTerm.trim()) return currenciesToFilter;

    const normalizedSearchTerm = searchTerm.toLowerCase();
    return currenciesToFilter.filter(
        (currency) =>
            currency.code.toLowerCase().includes(normalizedSearchTerm) ||
            currency.symbol.toLowerCase().includes(normalizedSearchTerm) ||
            Boolean(currency.description?.toLowerCase().includes(normalizedSearchTerm))
    );
};
